<script setup lang="ts">
interface BannerMessage {
  type: "success" | "warning" | "error" | "info";
  text: string;
}

defineProps<{
  variant: "success" | "warning" | "error" | "info";
  messages?: BannerMessage[];
}>();

const icon: Record<"success" | "warning" | "error" | "info", string> = {
  success: "✅",
  warning: "⚠️",
  error: "❌",
  info: "ℹ️",
};
</script>

<template>
  <div
    class="status-banner-base"
    :class="{
      'status-banner-success': variant === 'success',
      'status-banner-warning': variant === 'warning',
      'status-banner-error': variant === 'error',
      'status-banner-info': variant === 'info',
    }"
  >
    <template v-if="messages?.length">
      <div class="flex flex-col gap-3 py-1.5">
        <div
          v-for="(msg, idx) in messages"
          :key="idx"
          class="flex items-center gap-3"
        >
          <span class="text-[20px] leading-none">{{ icon[msg.type] }}</span>
          <span>{{ msg.text }}</span>
        </div>
      </div>
    </template>
    <template v-else>
      <span class="text-[20px]">{{ icon[variant] }}</span>
      <slot />
    </template>
  </div>
</template>
